import styled from "styled-components";
import { Link } from "react-router-dom";

import { createGlobalStyle } from "styled-components";
import background from "./background.jpg";

export const GlobalStyles = createGlobalStyle`
    a:link {
        text-decoration: none;
    }
    a:visited {
        text-decoration: none;
    }
`;
export const MainContainer = styled.div`
  font-family: "Inter", sans-serif;
  padding: 0;
  margin: 0;
  min-height: 100vh;
  width: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #111;
  flex-direction: column;
  background-image: url(${background});
  background-repeat: repeat;
`;
export const Navbar = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  width: 100%;
  height: 50px;
  backdrop-filter: blur(12px);
  background-color: rgba(220, 220, 220, 0.4);
`;
export const InnerNavbar = styled.div`
  display: flex;
  justify-content: center;
`;
export const NavLink = styled(Link)`
  font-size: 15px;
  color: #111;
  margin: 10px;
  transition: color 0.3s linear;
  &:hover {
    color: #dcdcdc;
  }
`;
export const CardTitle = styled.p`
  font-size: 26px;
  margin-bottom: 12px;
`;